import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const datePickerDefaultVariants = {}
const datePickerCompoundVariants = []

const datePickerSlotNames = [
  [
    "content",
    "datePicker__content"
  ],
  [
    "rangeRoot",
    "datePicker__rangeRoot"
  ],
  [
    "body",
    "datePicker__body"
  ],
  [
    "viewControl",
    "datePicker__viewControl"
  ],
  [
    "rangeText",
    "datePicker__rangeText"
  ],
  [
    "prevTrigger",
    "datePicker__prevTrigger"
  ],
  [
    "nextTrigger",
    "datePicker__nextTrigger"
  ],
  [
    "table",
    "datePicker__table"
  ],
  [
    "tableHead",
    "datePicker__tableHead"
  ],
  [
    "tableRow",
    "datePicker__tableRow"
  ],
  [
    "tableHeader",
    "datePicker__tableHeader"
  ],
  [
    "tableBody",
    "datePicker__tableBody"
  ],
  [
    "tableCell",
    "datePicker__tableCell"
  ],
  [
    "tableCellTrigger",
    "datePicker__tableCellTrigger"
  ],
  [
    "dayPill",
    "datePicker__dayPill"
  ],
  [
    "monthGroup",
    "datePicker__monthGroup"
  ],
  [
    "presetList",
    "datePicker__presetList"
  ],
  [
    "presetDivider",
    "datePicker__presetDivider"
  ],
  [
    "footer",
    "datePicker__footer"
  ]
]
const datePickerSlotFns = /* @__PURE__ */ datePickerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, datePickerDefaultVariants, getSlotCompoundVariant(datePickerCompoundVariants, slotName))])

const datePickerFn = memo((props = {}) => {
  return Object.fromEntries(datePickerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const datePickerVariantKeys = [
  "range"
]
const getVariantProps = (variants) => ({ ...datePickerDefaultVariants, ...compact(variants) })

export const datePicker = /* @__PURE__ */ Object.assign(datePickerFn, {
  __recipe__: false,
  __name__: 'datePicker',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: datePickerVariantKeys,
  variantMap: {
  "range": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, datePickerVariantKeys)
  },
  getVariantProps
})